// extracted by mini-css-extract-plugin
module.exports = {"popupTable":"PopupEvaluates_popupTable__1IEur","popupButtons":"PopupEvaluates_popupButtons__1w9to","red":"PopupEvaluates_red__2-Nbu","popup":"PopupEvaluates_popup__29K_M"};